"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBuffer = isBuffer;
const buffer_1 = require("buffer");
/**
 * Type guard to check if a value is a Buffer instance.
 * Works correctly with Buffer imported from the 'buffer' package.
 */
function isBuffer(value) {
    return buffer_1.Buffer.isBuffer(value);
}
//# sourceMappingURL=bufferUtils.js.map